export function formatarCpfCnpj(valor) {
    if (!valor) return "";
    const numeros = valor.replace(/\D/g, "");

    const formatos = {
        11: "$1.$2.$3-$4",
        14: "$1.$2.$3/$4-$5",
    };

    const regexes = {
        11: /(\d{3})(\d{3})(\d{3})(\d{2})/,
        14: /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    };

    return regexes[numeros.length]
        ? numeros.replace(regexes[numeros.length], formatos[numeros.length])
        : valor;
}